import { Component } from '@angular/core';
import { DemoRequestService } from 'src/app/dialogs/demo-choice-dialog/demo-request.service';

@Component({
  selector: 'app-ai-powered-interviews-section',
  templateUrl: './ai-powered-interviews-section.component.html',
  styleUrls: ['./ai-powered-interviews-section.component.scss'],
})
export class AiPoweredInterviewsSectionComponent {
  constructor(private demoRequestService: DemoRequestService) {}

  openDemoChoice() {
    this.demoRequestService.openDemoChoice();
  }
}
